"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuContext = exports.MenuContext = void 0;
var react_1 = require("react");
var noop_1 = require("../_util/noop");
exports.MenuContext = react_1.createContext({
    collapsed: false,
    setMobileCollapsed: noop_1.noop,
});
exports.SubMenuContext = react_1.createContext({
    inSubMenu: false,
    onTagChange: noop_1.noop,
    onSelectedChange: noop_1.noop,
});
//# sourceMappingURL=MenuContext.js.map